var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$apollo.loading)?_c('span',[_c('v-progress-circular',{attrs:{"indeterminate":""}})],1):(!_vm.calculated)?_c('span',[_vm._v("-")]):_c('tvos-jpy',{attrs:{"value":_vm.calculated.totalPrice}})}
var staticRenderFns = []

export { render, staticRenderFns }